import * as React from "react";
import { FC } from "react";
import classNames from "classnames";
import makeStyles from "@material-ui/core/styles/makeStyles";
import theme from "styles/theme";

// prettier-ignore
interface IProps {
    title?: string | JSX.Element;
    shouldUseCurrentColor?: boolean;
    className?: string;
    dataTestTitle?: string
    dataTestList?: string
}

export const Reminders: FC<IProps> = ({
    title,
    className,
    children,
    shouldUseCurrentColor,
    dataTestList,
    dataTestTitle,
}) => {
    const classes = useStylesReminderList({ shouldUseCurrentColor })({});
    return (
        <>
            {title && (
                <p className={classes.label} data-test={dataTestTitle}>
                    {title}
                </p>
            )}
            <ul className={classNames(classes.root, className)} data-test={dataTestList}>
                {children}
            </ul>
        </>
    );
};

type UseStylesReminderListProps = {
    shouldUseCurrentColor?: boolean;
};
const useStylesReminderList = ({ shouldUseCurrentColor }: UseStylesReminderListProps) =>
    makeStyles({
        root: {
            color: theme.palette.offBlack,
            fontWeight: 400,
            fontSize: 16,
            fontFamily: "Lato",
            "& li": {
                margin: "5px 0 0 0",
                minWidth: 200,
                paddingLeft: "1.5em",
                position: "relative",
                "&:before": {
                    content: '"\\2022"',
                    color: shouldUseCurrentColor ? "currentColor" : theme.palette.accent1Color,
                    fontWeight: "bold",
                    position: "absolute",
                    left: "7px",
                },
            },
        },
        label: {
            color: theme.palette.offBlack,
            fontWeight: 400,
            fontSize: 18,
            fontFamily: "Lato",
        },
    });

export default Reminders;
